import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { emergencybrodcastService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as emegencybroadcastActions from './actions';

export function fetchEmegencyBroadcasts(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_EMERGENCY_BROADCASTS),
    mergeMap(({ payload }) => {
      return emergencybrodcastService.getEmergencybroadcasts(payload)
        .pipe(
          map(res => emegencybroadcastActions.fetchEmegencyBroadcastsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function saveEmegencyBroadcast(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_EMERGENCY_BROADCAST),
    mergeMap(({ payload }) => {
      return emergencybrodcastService.saveEmergencyBroadcast(payload)
        .pipe(
          map(res => emegencybroadcastActions.saveEmegencyBroadcastSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function updateEmegencyBroadcast(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE_EMERGENCY_BROADCAST),
    mergeMap(({ payload }) => {
      return emergencybrodcastService.updateEmergencyBroadcast(payload)
        .pipe(
          map(res => emegencybroadcastActions.updateEmegencyBroadcastSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}